export const RESERVE_VEHICLE_REQUEST = "RESERVE_VEHICLE_REQUEST";
export const RESERVE_VEHICLE_SUCCESS = "RESERVE_VEHICLE_SUCCESS";
export const RESERVE_VEHICLE_ERROR = "RESERVE_VEHICLE_ERROR";
